import './Tag.scoped.scss'

const Tag = ({ children, color, fixedHeight = false, uppercase = false }) => <span className={`tag ${color || ''} ${fixedHeight ? 'fixed-height' : ''} ${uppercase ? 'uppercase' : ''}`}>{children}</span>

export default Tag
